/*Generated from the `:::slide{key="8af5a335-a64b-44ee-8d10-9cf0e8a2a81e" slug="high-tone"}` (simplified/001-P1/003/干.mdx) directive. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  return _jsx(_Fragment, {
    children: _jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      count: "1",
      children: _jsxs(html.p, {
        children: ["The ", _jsx(html.strong, {
          children: "high tone",
          components: html
        }), " ..."]
      }),
      components: html
    }),
    components: html
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
